var React = require('react');

function CaretUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.2373 15.4549L11.9894 8.207L4.7416 15.4549C4.7172 15.4793 4.6909 15.5006 4.6631 15.5189C4.4691 15.6471 4.2053 15.6257 4.0345 15.4549C3.8392 15.2596 3.8392 14.943 4.0345 14.7478L11.6359 7.1464C11.7296 7.0526 11.8568 6.9999 11.9894 6.9999C12.122 6.9999 12.2492 7.0526 12.343 7.1464L19.9444 14.7478C20.1137 14.9171 20.1362 15.1777 20.0118 15.3712C19.9928 15.4009 19.9703 15.4289 19.9444 15.4549C19.92 15.4793 19.8937 15.5006 19.8659 15.5189C19.799 15.5632 19.7237 15.5896 19.6468 15.5982C19.6282 15.6003 19.6095 15.6013 19.5908 15.6013C19.4629 15.6013 19.3349 15.5525 19.2373 15.4549Z","fill":"#121212"}));
}

CaretUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CaretUp;

CaretUp.default = CaretUp;
